import RecaptchaFix from "../../utils/RecaptchaFix";
import PostalCodeAutocomplete from "../../utils/PostalCodeAutocomplete";
import BaseDeviseController from "./BaseDeviseController";

export default class RegistrationsNew extends BaseDeviseController {

    constructor() {
        super();
        this.recaptchaFix = new RecaptchaFix('#login_customer');
        this.postalCodeAutocomplete = new PostalCodeAutocomplete();
        this.initValidation();
        this.setPasswordVisibility();
        this.bindEvents();
        this.toggleSubmit();
    }


    bindEvents() {
        $('#customer_first_name').off( 'keyup', this.toggleSubmit ).on("keyup", this.toggleSubmit )
        $('#customer_last_name').off( 'keyup', this.toggleSubmit ).on("keyup", this.toggleSubmit )
        $('#customer_email').off( 'keyup', this.toggleSubmit ).on("keyup", this.toggleSubmit )
        $('#customer_register_phone').off( 'keyup', this.toggleSubmit ).on("keyup", this.toggleSubmit )
        $('#customer_password').off( 'keyup', this.toggleSubmit ).on("keyup", this.toggleSubmit )
        $('#customer_postal_code').off( 'focusout', this.toggleSubmit ).on("focusout", this.toggleSubmit )
    }

    onDataChanged(data) {
    }

    onDestroy() {
        this.recaptchaFix.onDestroy();
        this.postalCodeAutocomplete.onDestroy();
    }

    toggleSubmit() {
        const fields = ['customer_first_name', 'customer_last_name', 'customer_email', 'customer_phone', 'customer_password', 'customer_address_postal_code', 'customer_address_city']

        let empty_field = fields.find( f => $(`#${f}`).val().trim() === '' )

        console.log(empty_field)
        if( empty_field === undefined) {
            $('#btn-register').removeClass('disabled')
        } else {
            $('#btn-register').addClass('disabled')
        }
    }

    initValidation() {
        application.setTemplateValidation({
            "customer[first_name]": {
                required: true,
                name_validation: true   
            },
            "customer[last_name]": {
                required: true,
                name_validation: true
            },
            "customer[email]": {
                required: true,
                email_validation: true
            },
            "customer[phone]": {
                required: true,
                phone_number_fr: true
            },
            "customer[password]": {
                required: true,
                password_validation: true
            },
            "customer[postal_code]": {
                //required: true,
                postal_code_validation: true,
                remote: {
                    url: $('#customer_postal_code').data('urlvalidate'),
                    data: {
                        postal_code: function() {
                            return $('#customer_address_postal_code').val();
                        }
                    }
                }
            }
        }, '#login_customer', true)
    }
}